import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'create-company-popup',
  templateUrl: './create-company-popup.component.html',
  styles: [],
})
export class PopupCreateCompanyComponent implements OnInit {
  selectedFile: File;
  selectedFileCertificate: File;

  formData = new FormData();

  newCompany = {
    Name: null,
    WebAddress: null,
    Address: null,
    Phone: null,
    Description: null,
    Email: null,
    ApplicationId: null,
    Certificate: null,
    WebDomain: null,
    CertificatePassword: null,
    FileLogo: null,
    FileCertificate: null,
  };

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.formData.append('test', 'test');
    window.console.log(this.formData.getAll('test'));
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] as File;
    this.newCompany.FileLogo = this.selectedFile;
  }

  onFileSelectedCertificate(event: any) {
    this.selectedFileCertificate = event.target.files[0] as File;
    this.newCompany.FileCertificate = this.selectedFileCertificate;
  }

  onSubmit() {
    if (this.selectedFile) {
    }
  }

  save() {
    this.onSubmit();
    this.newCompany.Name && this.formData.append('Name', this.newCompany.Name);
    this.newCompany.WebAddress && this.formData.append('WebAddress', this.newCompany.WebAddress);
    this.newCompany.Address && this.formData.append('Address', this.newCompany.Address);
    this.newCompany.Phone && this.formData.append('Phone', this.newCompany.Phone);
    this.newCompany.Description && this.formData.append('Description', this.newCompany.Description);
    this.newCompany.Email && this.formData.append('Email', this.newCompany.Email);
    this.newCompany.ApplicationId && this.formData.append('ApplicationId', this.newCompany.ApplicationId);
    this.newCompany.Certificate && this.formData.append('Certificate', this.newCompany.Certificate);
    this.newCompany.WebDomain &&  this.formData.append('WebDomain', this.newCompany.WebDomain);
    this.newCompany.CertificatePassword && this.formData.append('CertificatePassword', this.newCompany.CertificatePassword);

    // Agregamos los archivos si existen
    if (this.newCompany.FileLogo) {
      this.formData.append(
        'FileLogo',
        this.newCompany.FileLogo,
        this.newCompany.FileLogo.name
      );
    }

    if (this.newCompany.FileCertificate) {
      this.formData.append(
        'FileCertificate',
        this.newCompany.FileCertificate,
        this.newCompany.FileCertificate.name
      );
    }

    this.activeModal.close(this.formData)
  }

  cancel() {
    this.activeModal.dismiss();
  }

  isSaveButtonDisabled() {
    return Object.values(this.newCompany).some(
      (prop) => prop === null || prop === ''
    );
  }
}
